module.exports = __webpack_public_path__ + "img/close.adee8639.svg";